import { render, staticRenderFns } from "./ListadoPlanPagoUniversidad.vue?vue&type=template&id=50262c71"
import script from "./ListadoPlanPagoUniversidad.vue?vue&type=script&lang=js"
export * from "./ListadoPlanPagoUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ListadoPlanPagoUniversidad.vue?vue&type=style&index=0&id=50262c71&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports